import React, { useState, useEffect } from "react";
import IconBeneficiario from "../../Resources/svg/Icons/IconBeneficiario";

export interface Props {
  obligation: any;
  index: number;
  updateObligation: Function;
  removeObligation: Function;
  count: number;
  countries: any[];
}

export const ObligationAbroadForm = ({
  obligation,
  index,
  updateObligation,
  removeObligation,
  count,
  countries = [],
}: Props) => {
  const [data, setData] = useState<any>(obligation);
  const [errors, setErrors] = useState<any>({
    codigoPais: false,
    obligacionTributaria: false,
  });
  const [isDuplicateCountry, setIsDuplicateCountry] = useState(false);

  useEffect(() => {
    setData(obligation);

    const hasErrors =
      !obligation.codigoPais ||
      !obligation.obligacionTributaria ||
      obligation.obligacionTributaria.trim() === "";

    updateObligation(obligation, index, hasErrors);
  }, [obligation]);

  const validate = (name: any, value: any) => {
    let valid = true;
    switch (name) {
      case "codigoPais":
        if (!value || value === "") {
          valid = false;
        }
        break;
      case "obligacionTributaria":
        if (!value || value.toString().trim().length === 0) {
          valid = false;
        } else if (!/^[a-zA-Z0-9]*$/.test(value)) {
          valid = false;
        } else if (value.length > 30) {
          valid = false;
        }
        break;
    }
    errors[name] = !valid;
    setErrors({ ...errors });
    return valid;
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    let newValue = value;
    const clon = { ...data };

    if (name === "codigoPais") {
      const selectedCountry = countries.find((c) => c.codigo === value);
      clon.descripcionPais = selectedCountry ? selectedCountry.descripcion : "";
      setIsDuplicateCountry(!selectedCountry);
    }

    if (name === "obligacionTributaria") {
      newValue = value.replace(/[^a-zA-Z0-9]/g, "");
    }

    clon[name] = newValue;
    setData(clon);
    validate(name, newValue);

    let errorValidation = false;
    Object.entries(errors).some((item) => {
      if (item[1]) {
        errorValidation = true;
        return true;
      }
    });

    updateObligation(clon, index, errorValidation);
  };

  const remove = (e: any) => {
    e.preventDefault();
    removeObligation(index);
  };

  return (
    <div
      className={`beneficiaryForm${index === 0 ? " first" : ""}`}
      style={{ position: "relative", margin: "15px 0px 0px 0px" }}
    >
      <div
        className="clientForm__beneficiary-box"
        style={{ margin: "10px 0px 0px 0px" }}
      >
        <div className="clientForm__beneficiary-box-icon">
          <IconBeneficiario />
          <div className="clientForm__beneficiary">
            Obligación tributaria {index + 1}
          </div>
        </div>
        {count > 1 && (
          <p
            className="clientForm__eliminar"
            onClick={(e) => {
              remove(e);
            }}
          >
            Eliminar
          </p>
        )}
      </div>
      <div>
        <div className="column-2-oa">
          <div
            className="clientForm__control input-field fondo--1"
            style={{ width: "75%" }}
          >
            <select
              name="codigoPais"
              value={data.codigoPais || ""}
              onChange={(e) => handleChange(e)}
              className={errors.codigoPais || isDuplicateCountry ? "is-error" : ""}
            >
              <option value="" disabled selected>
                País
              </option>
              {countries.map((country, i) => (
                <option key={i} value={country.codigo}>
                  {country.descripcion}
                </option>
              ))}
            </select>
            {isDuplicateCountry && (
              <span
                style={{
                  color: "#ff1c44",
                  fontSize: "12px",
                  fontFamily: "Lato",
                  marginTop: "4px",
                  display: "block",
                }}
              >
                Este país ya ha sido seleccionado
              </span>
            )}
          </div>

          <div className="clientForm__control input-field">
            <input
              type="text"
              autoComplete="off"
              id={`obligacionTributaria_${index}`}
              name="obligacionTributaria"
              value={data.obligacionTributaria || ""}
              onChange={(e) => handleChange(e)}
              maxLength={30}
              className={errors.obligacionTributaria ? "is-error" : ""}
            />
            <label htmlFor={`obligacionTributaria_${index}`}>
              N° de identificación tributaria
            </label>
            {errors.obligacionTributaria && (
              <span
                style={{
                  color: "#ff1c44",
                  fontSize: "12px",
                  fontFamily: "Lato",
                  marginTop: "4px",
                  display: "block",
                }}
              >
                Solo se permiten caracteres alfanuméricos (a-z, A-Z, 0-9)
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
